export function detectAndroid() {
  return /Android/i.test(navigator.userAgent);
}
